var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800781 10V4C0.800781 2.89543 1.69621 2 2.80078 2H15.2008C16.3053 2 17.2008 2.89543 17.2008 4V10",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.00201,
    cy: 8.00006,
    rx: 2.00006,
    ry: 2.00006,
    stroke: "#5C6370",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6699 10.6669C13.5904 10.6669 14.3366 9.92071 14.3366 9.00021C14.3366 8.07971 13.5904 7.3335 12.6699 7.3335",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 16.6676C13.0002 16.6676 11.5775 16.6676 9.00012 16.6676C6.42271 16.6676 5 16.6676 5 16.6676C5 14.4584 6.42271 12.6675 9.00012 12.6675C11.5775 12.6675 13.0002 14.4584 13.0002 16.6676Z",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 16.6676C15.6661 16.6676 16.9994 16.6676 16.9994 16.6676C16.9994 14.4584 14.9994 13.0008 13.666 12.6675",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 10.6669C4.41153 10.6669 3.66532 9.92071 3.66532 9.00021C3.66532 8.07971 4.41153 7.3335 5.33203 7.3335",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33396 16.6676C2.33393 16.6676 1.00055 16.6676 1.00055 16.6676C1.00055 14.4584 3.00061 13.0008 4.33398 12.6675",
    stroke: "#5C6370",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.cad708ab7d0471f4a7f65982073cafb6.svg";
export { ForwardRef as ReactComponent };